export class CarouselWide {
  constructor(Flickity) {
    this.gallery = document.querySelector('.carousel-wide');
    this.header = document.querySelector('.page-header');
    if (!this.gallery || !this.header) {
      return;
    }

    this.setHeaderColor = this.setHeaderColor.bind(this);
    this.initCarousel(Flickity);
  }

  initCarousel(Flickity) {
    this.carousel = new Flickity(this.gallery, {
      arrowShape:
        'M73.75 1.676L71.947 0 26.25 50.11 71.951 100l1.799-1.68-44.165-48.214L73.75 1.676z',
      wrapAround: true,
      dragThreshold: 15,
      setGallerySize: false,
      resize: true,
      autoPlay: 4000,
      pauseAutoPlayOnHover: false,
    });

    this.setHeaderColor();
    this.carousel.on('select', this.setHeaderColor);
  }

  setHeaderColor() {
    if (this.carousel.selectedElement && this.carousel.selectedElement.classList.contains('u-white-copy')) {
      this.header.classList.add('u-white-copy');
      this.gallery.classList.add('white-copy-slide');
    } else {
      this.header.classList.remove('u-white-copy');
      this.gallery.classList.remove('white-copy-slide');
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/carousel-wide.js